// import { getFilterFromLocalStorage, getTempFilterFromLocalStorage } from '../HelperMethods/LocalStorageUtils';

export default {
  appReducer: {
    assets: [],
    fields: [],
    fieldsForDropdown: [],
    areasForDropdown: [],
    allAreas: [],
    allAreasUserHasAccessTo: [],
    loggedInUser: {},
    selectedField: {},
    selectedAreas: [],
    tenantId: '',
    users: [],
    settings: {},
    engineSettings: {
      scoreCoefficient: 1,
      timeLimit: 5000,
      highScoreThreshold: 1000,
      highScoreCoefficient: 2,
    },
    selectedRunEngineSettings: null,
    isAppLoading: true,
    selectedFilter: {},
    tempCreatedFilter: {},
    packagesInfo: {},
    taskTypeGroups: [],
    taskTypeGroupsForDropdown: [],
    selectedTaskTypeGroups: [],
    userConfig: {},
    initialUserConfig: {},
    statusConfig: {},
  },
  areaReducer: {
    areas: [],
    stops: [],
    allStops: [],
    area: null,
    loading: true,
    rawAreas: [],
  },
  commentReducer: {
    comments: [],
    isLoading: false,
    addCommentLoading: false,
    taskIdForComments: null,
  },
  taskTypeReducer: {
    taskTypes: [],
    pickList: [],
    certificatesPickListOptions: [],
    skillLevelPickListOptions: [],
    isLoading: true,
    pickListLoading: false,
  },
  teamReducer: {
    teams: [],
    isLoading: false,
  },
  stopsReducer: {
    stops: [],
    isLoading: false,
  },
};
